// extracted by mini-css-extract-plugin
export var container = "_25-0";